export const getEmptyPeriodicidade = () => ({
  id: null,
  periodicidade: null,
  valor_base: null,
  desc_boleto: null,
  desc_pix: null,
  parcelas_credito: null,
  max_payments: null,
  is_default: false,
});
